import {
  ADD_TERMINAL,
  ADD_TERMINAL_FAILURE,
  ADD_TERMINAL_SUCCESS,
  //
  DELETE_TERMINAL,
  DELETE_TERMINAL_FAILURE,
  DELETE_TERMINAL_SUCCESS,
  //
  EDIT_TERMINAL,
  EDIT_TERMINAL_FAILURE,
  EDIT_TERMINAL_SUCCESS,
  //
  FETCH_TERMINALS,
  FETCH_TERMINALS_FAILURE,
  FETCH_TERMINALS_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
} from "./constants";

// List
export const fetchTerminals = (payload) => ({
  type: FETCH_TERMINALS,
  payload,
});
export const fetchTerminalsSuccess = (payload) => ({
  type: FETCH_TERMINALS_SUCCESS,
  payload,
});
export const fetchTerminalsFailure = (payload) => ({
  type: FETCH_TERMINALS_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addTerminal = (payload) => ({
  type: ADD_TERMINAL,
  payload,
});
export const addTerminalSuccess = (payload) => ({
  type: ADD_TERMINAL_SUCCESS,
  payload,
});
export const addTerminalFailure = (payload) => ({
  type: ADD_TERMINAL_FAILURE,
  payload,
});
// EDIT
export const editTerminal = (payload) => ({
  type: EDIT_TERMINAL,
  payload,
});
export const editTerminalSuccess = (payload) => ({
  type: EDIT_TERMINAL_SUCCESS,
  payload,
});
export const editTerminalFailure = (payload) => ({
  type: EDIT_TERMINAL_FAILURE,
  payload,
});
// DELETE
export const deleteTerminal = (payload, onDelete) => ({
  type: DELETE_TERMINAL,
  payload,
  onDelete,
});
export const deleteTerminalSuccess = (payload) => ({
  type: DELETE_TERMINAL_SUCCESS,
  payload,
});
export const deleteTerminalFailure = (payload) => ({
  type: DELETE_TERMINAL_FAILURE,
  payload,
});
